import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/EngagementCampaignReportGrid.graphql';
import { Query, QueryengagementCampaignReportGridArgs } from '../../__generated__/globalTypes';

export const useEngagementCampaignReportGridQuery = (
  options?: QueryHookOptions<Query, QueryengagementCampaignReportGridArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryengagementCampaignReportGridArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useEngagementCampaignReportGridLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryengagementCampaignReportGridArgs>
): QueryResult<Query, QueryengagementCampaignReportGridArgs> & {
  getEngagementCampaignReportGrid: LazyQueryExecFunction<Query, QueryengagementCampaignReportGridArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getEngagementCampaignReportGrid, result] = useLazyQuery<Query, QueryengagementCampaignReportGridArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getEngagementCampaignReportGrid, ...result };
};

export const useEngagementCampaignReportGridPromiseQuery = () => {
  const client = useApolloClient();

  const getEngagementCampaignReportGrid = useCallback(
    (options?: Omit<QueryOptions<QueryengagementCampaignReportGridArgs, Query>, 'query'>) =>
      client.query<Query, QueryengagementCampaignReportGridArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getEngagementCampaignReportGrid };
};
// Suspense Query Hooks
export const useEngagementCampaignReportGridSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryengagementCampaignReportGridArgs>
) => {
  const result = useSuspenseQuery<Query, QueryengagementCampaignReportGridArgs>(QUERY, {
    ...options
  });

  return result;
};
